import { AddressDTO } from "./addressDTO";

export class UserReportDTO{
    public id!: number;
    public roleName!: string;
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public phoneNumber!: string;
    public entityType!: string;
    public entityName!: string;
    public entityCreated? :string;
    public entityAddressList!: AddressDTO[];
    public lockoutEnabled!: boolean;
    public twoFactorEnabled!: boolean;
    public deleted!: boolean;
    public premierIntegrations!: string[];
}